import { Box, Typography } from '@mui/material';
import { CustomTextFieldAmount } from 'components/common';
import { Control } from 'react-hook-form';
import { OnePagerFormFields } from './OnePagerForm';

interface MarketBoxProps {
  control: Control<OnePagerFormFields, object>;
  currency: 'inr' | 'usd';
  name: 'tam' | 'sam' | 'som';
  description: string;
  fieldName: string;
}

export const MarketBox = ({
  control,
  currency,
  name,
  description,
  fieldName,
}: MarketBoxProps) => {
  return (
    <Box display="flex" justifyContent="space-between">
      <Box flexBasis="60%">
        <Typography
          component="label"
          color="rgba(17, 17, 17, 0.7)"
          fontSize={14}
          lineHeight="20px"
          display="block"
        >
          {name.toUpperCase()}
        </Typography>
        <Typography
          component="span"
          color="rgba(17, 17, 17, 0.7)"
          fontSize={10}
        >
          ({description})
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="baseline">
        <CustomTextFieldAmount
          control={control}
          placeholder="Enter amount"
          name={fieldName}
          currency={currency}
          textAlign="right"
          variant="standard"
        />
        <Typography component="span" width={40} align="right">
          {currency === 'inr' ? 'cr' : 'M$'}
        </Typography>
      </Box>
    </Box>
  );
};
